import React from "react";
import { useSelector } from "react-redux";
import CumulativeChart from "../Common/Components/Charts/CumulativeLineChart";
import { machineTimesToHours } from "../Common/Util_methods/format";
import { getMachineTimesLoadingSelector, getMachineTimesSelector } from "./slice";
import {machineTimeColors} from "../Common/Constants"
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";

interface WidgetProps {
    id: string;
    header: string;
}

const CumulativeChartWidget = (props: WidgetProps) => {

    const machineTimesData = useSelector(getMachineTimesSelector);
    const loadingState = useSelector(getMachineTimesLoadingSelector);
    

    if (loadingState === "pending") return <Spinner text="data" />;
    if (loadingState === "rejected") {
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if(machineTimesData.length === 0){
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    return (
        <CumulativeChart
            data={machineTimesToHours(machineTimesData)}
            id="machine-times-cumulative-chart"
            header="Cumulative Machine Times"
            cumulativeFields={[ 
                {field:"idleAfterFailureDuration",color:machineTimeColors.idleAfterFailure},
                {field:"idleAfterRunningDuration",color:machineTimeColors.idleAdferRunning},
                {field:"failureTimeoutDuration", color:machineTimeColors.failureTimeout}, 
                {field:"failureDuration", color:machineTimeColors.failure}, 
                {field:"runningDuration", color:machineTimeColors.running},
                {field:"shiftDuration", color:machineTimeColors.shift}, 
            ]}
        />
    )
}

export default CumulativeChartWidget;